import React, { useEffect, useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { connect } from "react-redux";
import CourseCard from "components/widget/CourseCard";
import { 
	getTrainingClassList, 
} from "../../../../../redux/trainingclass/trainingClassState";
import { LucideBookOpen } from "lucide-react";



const BrowseTrainingTable = ({
	recordList, 
	pagination, 
	doSearch,
}) => {

const [availableCourses, setAvailableCourses] = useState([]);

useEffect(() => {
	doSearch({ paginate: pagination?.per_page});
}, [doSearch, pagination?.per_page]);

useEffect(() => {
	const filtered = recordList?.filter(course => !course.is_enrolled) || [];
	setAvailableCourses(filtered);
}, [recordList]);

return (
	<HeaderComponent
		title="Browse Training	"
		description="Explore available courses and programs"
		labelIcon={<LucideBookOpen size={20} />}
	>
			<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-4" >
					{availableCourses.length > 0 ? (
						availableCourses.map((course) => (
							<CourseCard
								key={course.tcl_id}
								recordData={course}
							/>
						))
					) : (
						<p className="text-gray-500 text-center col-span-full">
							No available classes found.
						</p>
					)}
			</div>
	</HeaderComponent>

  );
};


const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseTrainingTable);
